import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import WorkWithMe from "../pages/work-with-me/page";
import Shop from "../pages/shop/page";
import Contact from "../pages/contact/page";
import WomenWhoHeal from "../pages/women-who-heal/page";
import OrderConfirmation from "../pages/order-confirmation/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsConditions from "../pages/terms/page";
import Shipping from "../pages/shipping/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/work-with-me",
    element: <WorkWithMe />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/women-who-heal",
    element: <WomenWhoHeal />,
  },
  {
    path: "/order-confirmation",
    element: <OrderConfirmation />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsConditions />,
  },
  {
    path: "/shipping",
    element: <Shipping />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;